<template>
  <div class="drafts-table-content">
    <a-table
      :columns="columns"
      :dataSource="tableList"
      :pagination="pagination"
      @change="tableChange"
      class="drafts-table"
    >
      <template slot="operation" slot-scope="text, record, index">
        <div class="editable-row-operations">
          <span>
            <a @click="() => edit(record.key)" class="operation-text">编辑</a>
            <a-popconfirm
              title="是否确定删除该计划?"
              @confirm="() => deleteColumn(record.key)"
            >
              <a class="operation-text">删除</a>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </a-table>
  </div>
</template>
<script>
import moment from "moment";
import api from "../../commomFun/api.js";
const storage = window.sessionStorage;

const columns = [
  {
    title: "计划名称",
    dataIndex: "planName",
    width: "259px",
    scopedSlots: { customRender: "planName" },
    align: 'left'
  },
  {
    title: "保存时间",
    dataIndex: "saveTime",
    width: "229px",
    scopedSlots: { customRender: "saveTime" },
    align: 'left'
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    align: 'left'
  },
];


export default {
  props: {
    tableList: Array,
    cacheData: Array,
    getListTaskByPage: Function,
    listTotal: Number
  },
  data () {
    return {
      columns,
      pageNum: 1,
      pagination: { defaultPageSize: 5, total: 10 }
    };
  },
  updated () {
    const paginations = this.pagination
    paginations.total = this.listTotal
    this.pagination = paginations
  },
  methods: {
    tableChange (value) {
      this.pageNum = value.current
      this.getListTaskByPage(value.current)
    },
    seletStep (data) {
      const { devInfo } = data;

      Object.keys(devInfo).forEach(key => {
        try {
          if (key == 'selectedList') {
            this.$localForage.setItem('selectedList',devInfo[key]);
          } else {
            const cachaeItem = JSON.parse(devInfo[key])
            sessionStorage.setItem(key, JSON.stringify(cachaeItem))
          }
        } catch {
          sessionStorage.setItem(key, JSON.stringify(devInfo[key]))
        }
      })
      this.$router.push('/channelPlanSet');
    },
    edit (key) {
      sessionStorage.setItem('edit', '');
      sessionStorage.setItem('planId', '');
      sessionStorage.removeItem('conditionList');
      sessionStorage.removeItem('formItem');
      sessionStorage.removeItem('planId');
      sessionStorage.removeItem('materialDetailsList');
      // sessionStorage.removeItem('selectedList')
      this.$localForage.removeItem('selectedList', ()=>{})
      sessionStorage.removeItem('areaDataListRow')
      sessionStorage.removeItem('selectedInfo')
      sessionStorage.setItem('planSetType', 'create');
      sessionStorage.setItem('targetSetType', 'create');
      sessionStorage.setItem('materialSetType', 'create');
      sessionStorage.setItem('draftId', '')
      let draftsData = {}
      this.cacheData.forEach(item => {
        if (item.draftId === key) {
          draftsData = item
        }
      })
      if (draftsData.planInfo) {
        sessionStorage.setItem('formItem', JSON.stringify(draftsData.planInfo))
        sessionStorage.setItem('step', 2)
      }
      sessionStorage.setItem("draftId", key)
      this.seletStep(draftsData)
      return null
    },
    deleteColumn (key) {
      api.postApi_header('/draft/plan/delete', '', { draftId: key }).then(res => {
        const { code } = res.data
        if (code === 200) {
          this.getListTaskByPage(this.pageNum)
          this.$message.success('删除记录成功！');
        }
      })
    },
  },
};
</script>
<style lang="scss">
.editable-row-operations a {
  margin-right: 8px;
}

.drafts-table-content {
  padding-top: 16px;
  padding-left: 32px;
  padding-right: 32px;
  min-height: 300px;
  .drafts-table {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding: 0;
      padding-top: 12px;
      padding-bottom: 12px;
      padding-left: 8px;
      font-size: 14px;
      font-family: 'PingFangSC-Medium, PingFang SC';
      line-height: 21px;
      color: #041427;
      text-align: center;
    }
  }
  .operation-text {
    font-size: 14px;
    font-family: 'PingFangSC-Regular, PingFang SC';
    font-weight: 400;
    color: rgba(24, 144, 255, 1);
    line-height: 21px;
  }
}
</style>
